<!-- 到期交收 -->
<template>
  <div id="MyTradeDueToDelivery">
    <el-table ref="tableData" :data="tableData" :header-cell-style="{background:'#ffffff',borderRight:'1px solid #474747',padding:'5px 0px'}">
      <template slot="empty">
        <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 100px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div></div>
        <div v-else class="no-datas1"><div class="no-data-img" style="margin: 100px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
      </template>
      <el-table-column prop="createTime" label="时间" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | dateFormate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="expiredId" label="配对单号">
      </el-table-column>
      <!-- <el-table-column prop="sellHoldStatus" label="仓单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.sellHoldStatus== 2">已仓单抵顶</span>
          <span v-if="scope.row.sellHoldStatus== 0">未仓单抵顶</span>
          <span v-if="scope.row.sellHoldStatus== 1">未入库</span>
        </template>
      </el-table-column> -->
      <!-- buyStatus -->
      <el-table-column prop="sellStatus" label="卖方状态">
        <!-- <template slot-scope="scope">
          <span v-if="scope.row.sellStatus == 0">正常</span>
          <span v-if="scope.row.sellStatus == 1">数量不足</span>
          <span v-if="scope.row.sellStatus == 2">未入库</span>
        </template> -->
      </el-table-column>
      <!-- sellStatus -->
      <el-table-column prop="buyStatus" label="买方状态">
        <!-- <template slot-scope="scope">
          <span v-if="scope.row.buyStatus == 0">正常</span>
          <span v-if="scope.row.buyStatus == 1">数量不足</span>
        </template> -->
      </el-table-column>
      <!-- <el-table-column label="交收状态">
        <template slot-scope="scope">
          <span v-if="scope.row.deliveryStatus== 0">待确认</span>
          <span v-if="scope.row.deliveryStatus== 1">提交验货函</span>
          <span v-if="scope.row.deliveryStatus== 2">确认违约</span>
          <span v-if="scope.row.deliveryStatus== 3">已提交验货确认函</span>
          <span v-if="scope.row.deliveryStatus== 4">已开具提货单</span>
          <span v-if="scope.row.deliveryStatus== 5">已确认验货</span>
          <span v-if="scope.row.deliveryStatus== 6">存在争议</span>
          <span v-if="scope.row.deliveryStatus== 7">已完成</span>
          <span v-if="scope.row.deliveryStatus== 8">已解冻保证金</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="deliveryStatus" label="交收状态"></el-table-column>
      <!-- <el-table-column prop="className" label="商品类别" /> -->
      <el-table-column prop="commodityName" label="商品名称" width="110px">
      </el-table-column>
      <el-table-column prop="bsFlag" label="买/卖">
        <template slot-scope="scope">
          <span v-if="scope.row.bsFlag== 'B'" class="increaseColor">买</span>
          <span v-if="scope.row.bsFlag== 'S'" class="dropColor">卖</span>
        </template>
      </el-table-column>
      <el-table-column prop="waitDayNum" label="验货天数">
      </el-table-column>
      <el-table-column prop="quantity" label="交收数量">
      </el-table-column>
      <el-table-column prop="weight" label="交收重量">
      </el-table-column>
      <el-table-column prop="deliveryPrice" label="交收价格">
      </el-table-column>
      <!-- <el-table-column prop="holdMargin" label="交收担保金" width="100px">
        <template slot-scope="scope">
          <span v-if="scope.row.bsFlag== 'B'">{{scope.row.buyHoldMargin}}</span>
          <span v-if="scope.row.bsFlag== 'S'">{{scope.row.sellHoldMargin}}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="holdMargin" label="交收担保金" width="100px"></el-table-column>
      <!-- <el-table-column prop="createTime" label="交收时间" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | dateFormate }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="scope">
          <!-- <el-button v-if="(scope.row.sellHoldStatus == 0 || scope.row.sellHoldStatus == 2) && scope.row.deliveryStatus == 0" size="mini" @click="showDia(scope.row)">验收确认</el-button> -->
          <el-button v-if="scope.row.bsFlag=='B' && scope.row.buyStatus=='正常' && scope.row.sellStatus=='正常' && scope.row.deliveryStatus == '待确认'" size="mini" @click="showDia(scope.row)">验货确认</el-button>
          <!-- <el-button v-if="scope.row.deliveryStatus== 4" size="mini" @click="showDia1(scope.row)">收货确认</el-button> -->
          <!-- <el-button size="mini" @click="test">测试</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-row v-if="pageData.total">
      <el-col :span="24" class="paginateWrap">
        <el-pagination
          popper-class="_popStyle"
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      class="newPopup"
    >
      <span>您确定要验货确认吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="canclexBtn" @click="dialogVisible = false">取 消</el-button>
        <el-button class="surexBtn" type="primary" @click="gettingData">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 取消此功能20220418 -->
    <!-- <el-dialog
      title="收货确认"
      :visible.sync="dialogVisible1"
      width="30%"
    >
      <span>是否收货确认？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="gettingData1">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
/*global http protocol*/
export default {
  name: 'TradeDueToDelivery',
  props: ['time', 'isSearch'],
  data() {
    return {
      row: {},
      dialogVisible: false,
      dialogVisible1: false,
      isNetWrong: false,
      tableData: [],
      // 分页
      pageData: {
        total: null,
        pageSizes: [5, 10, 20, 30, 40, 50, 60],
        pageSize: 20,
        currentPage: 1
      },
      beginTime: [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
    }
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 验货确认
    showDia(row) {
      this.row = {}
      this.row = row
      this.dialogVisible = true
    },
    // 验货
    gettingData() {
      // protocol.param_buyInspectionDeliveryConfirmt.data.expiredId = this.row.expiredId
      protocol.param_buyCloseDeliveryConfirm.data.expiredId = this.row.expiredId
      http.gPost(protocol.param_buyCloseDeliveryConfirm).then(response => {
        const { code, message } = response.data
        if (Number(code) === 0) {
          this.$message({ message: message })
          this.dialogVisible = false
          this.row = {}
          setTimeout(() => {
            this.showData()
          }, 1000)
        } else {
          this.dialogVisible = true
          this.$message({ message: message })
        }
      }).catch((e) => {
      })
    },
    // 收货确认
    showDia1(row) {
      this.row = {}
      this.row = row
      this.dialogVisible1 = true
    },
    gettingData1() {
      protocol.param_buyCloseDeliveryConfirm.data.expiredId = this.row.expiredId
      http.gPost(protocol.param_buyCloseDeliveryConfirm).then(response => {
        const { code, message } = response.data
        if (Number(code) === 0) {
          this.$message({ message: message })
          this.dialogVisible1 = false
          this.row = {}
          this.showData()
        } else {
          this.dialogVisible1 = true
          this.$message({ message: message })
        }
      }).catch((e) => {
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 查询数据
    showData() {
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        protocol.param_getExpireTradeList.data.startTradeDay = this.time[0]
        protocol.param_getExpireTradeList.data.endTradeDay = this.time[1]
      } else {
        protocol.param_getExpireTradeList.data.startTradeDay = null
        protocol.param_getExpireTradeList.data.endTradeDay = null
      }
      protocol.param_getExpireTradeList.data.page =
          this.pageData.currentPage - 1
      protocol.param_getExpireTradeList.data.size =
          '' + this.pageData.pageSize
      protocol.param_getExpireTradeList.data.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'createTime' // "//排序属性"
        }]
      http.gPost(protocol.param_getExpireTradeList).then(response => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          this.tableData = value.content
          this.pageData.total = value.totalElements
        } else {
          this.$message({ message: message })
        }
      }).catch((e) => {
      })
    }
  }
}
</script>
<style scoped lang="scss">
.newPopup{
  /deep/.el-dialog{
  width:480px;
  border-radius: 8px;
  background-color:#2C2C2C!important;
  }
  /deep/.el-dialog__body{
    padding:10px 40px 40px;
    span{
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.9)!important;
    }
  }
  /deep/.el-dialog__headerbtn{
    top:40px;
    .el-dialog__headerbtn .el-dialog__close{
      font-size:22px;
      color: rgba(255, 255, 255, 0.2);
    }
  }
  /deep/.el-dialog__footer{
    text-align:center;
    padding:10px 40px 40px !important;
    .el-button{
      width: 95px;
      height: 40px;
      background: #E6F1FC;
      border-radius: 4px;
      border: none;
      span{
       color:#1989FA!important;
     }
    }
    .surexBtn{
      background: #0486FE;
      margin-left:25px;
     span{
       color:#fff !important;
     }
    }
  }
  // /deep/.el-dialog__header{
  //   display:none;
  // }
  /deep/.el-table .el-button .sureButton {
    height: 14px;
    border-radius: 4px;
    border: 1px solid #363f66;
    padding: 6px 8px;
    margin-right: 5px;
  }
}
/deep/.el-button{
  // height: 14px;
  border-radius: 4px;
  border: 1px solid #363f66;
  padding: 6px 8px;
  background: none;
}
</style>
<style>
  #MyTradeDueToDelivery *{
    color: #bfc3ce;
  }

#MyTradeDueToDelivery .el-tabs__item{
  font-size: 16px;
  height: 50px;
  line-height: 50px;
}
#MyTradeDueToDelivery .el-tabs__nav-wrap::after {
  width: 0;
}
#MyTradeDueToDelivery .el-tabs__header{
  margin-bottom: 0;
}
#MyTradeDueToDelivery .el-dialog {
  border-radius: 10px;
  background:rgba(38,53,98,1);
}
#MyTradeDueToDelivery  .eleInputText .el-input__inner{
  background:rgba(38,53,98,1);
}
#MyTradeDueToDelivery .el-dialog__footer {
  padding: 20px;
}
#MyTradeDueToDelivery .el-dialog__footer::after {
  content: "";
  display: block;
  clear: both;
}
#MyTradeDueToDelivery .el-form-item__label {
  color: white;
}
.cancel-btn span {
  color: #409eff;
}

#sec .el-tabs__item{
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
#sec .is-active{
  background-color: #409EFF;
  border-radius: 30px;
  color: #FFFFFF;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  border-bottom: none;
}
#sec .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),#sec .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),#sec .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),#sec  .el-tabs--top .el-tabs__item.is-top:nth-child(2){
  padding: 0 20px;
}
#sec  .el-tabs--bottom .el-tabs__item.is-bottom:last-child,#sec .el-tabs--bottom .el-tabs__item.is-top:last-child,#sec .el-tabs--top .el-tabs__item.is-bottom:last-child, #sec .el-tabs--top .el-tabs__item.is-top:last-child{
  padding: 0 20px;
}
#MyTradeDueToDelivery .el-pagination{
  margin-top: 50px;
  text-align: center;
}
#MyTradeDueToDelivery .el-loading-mask{
   background: #ffffff;
}
#MyTradeDueToDelivery .el-icon-more{
  color: #FFFFFF;
}
#MyTradeDueToDelivery .selecttime{
  margin: 15px;
}
#MyTradeDueToDelivery .new-title-record-bonus-box .el-tabs__item.is-active {
  border-bottom: none;
}
#MyTradeDueToDelivery .el-date-editor--datetime .el-input__inner {
color: #EEEFF7;
height: 40px;
box-sizing: border-box;
margin: 0 auto;
border-radius: 2px;
border: 1px solid rgba(220,223,234,.3);
background: linear-gradient(360deg, rgba(38,53,98,1) 0, rgba(38,53,98,1) 100%);
cursor: pointer;
}

</style>
<style>
#MyTradeDueToDelivery .el-table--border::after,#MyTradeDueToDelivery .el-table--group::after, .el-table::before{
 background-color:transparent;
}
#MyTradeDueToDelivery .el-table td,#MyTradeDueToDelivery .el-table th.is-leaf{
     border-bottom: 1px solid #474747;
}
#MyTradeDueToDelivery .el-table--border,#MyTradeDueToDelivery .el-table--group{
 border:none;
}
#MyTradeDueToDelivery .el-table td div{
  text-align:center;
  font-size:14px;
  color:#fff;
}
#MyTradeDueToDelivery .el-table--border td, #MyTradeDueToDelivery .el-table--border th,#MyTradeDueToDelivery .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #474747;
}
#MyTradeDueToDelivery .el-pagination button:disabled,
#MyTradeDueToDelivery .el-pagination .btn-prev,
#MyTradeDueToDelivery .el-pagination .btn-next,
#MyTradeDueToDelivery .el-pager li,
#MyTradeDueToDelivery .el-pagination__editor.el-input .el-input__inner,
#MyTradeDueToDelivery .el-pagination .el-select .el-input .el-input__inner,
#MyTradeDueToDelivery .el-table table tr,
#MyTradeDueToDelivery .el-table th,
#MyTradeDueToDelivery .el-table,
#MyTradeDueToDelivery .el-table__footer-wrapper tbody td,
#MyTradeDueToDelivery .el-table__header-wrapper tbody td {
  background: #ffffff;
}
#MyTradeDueToDelivery .el-table td,#MyTradeDueToDelivery .el-table th{
    padding:2px 0;
}
#MyTradeDueToDelivery .el-table__footer-wrapper td{
    border-top:none;
}
#MyTradeDueToDelivery .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
#MyTradeDueToDelivery .el-table__body tr.current-row > td,
#MyTradeDueToDelivery .el-table__body tr.hover-row.current-row > td,
#MyTradeDueToDelivery .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
#MyTradeDueToDelivery .el-table__body tr.hover-row.el-table__row--striped > td,
#MyTradeDueToDelivery .el-table__body tr.hover-row > td,
#MyTradeDueToDelivery  .el-table th.el-table__cell {
  background: #ffffff;
}
#MyTradeDueToDelivery .el-table__header-wrapper th > .cell{
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  text-align:center;
}
#MyTradeDueToDelivery .el-table .el-table__cell{
  padding:4px 0;
  /* border-right: 1px solid #505050; */
}
#MyTradeDueToDelivery .el-table td.el-table__cell,#MyTradeDueToDelivery .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);;
}

</style>
